export default __webpack_public_path__ + "static/media/desenvolvimento_de-software.ee87da24.mp4";